module.exports = __webpack_public_path__ + "static/img/automationnew.c59e011e.png";